import { render, staticRenderFns } from "./dadosPessoais.vue?vue&type=template&id=4dff40df&"
import script from "./dadosPessoais.vue?vue&type=script&lang=js&"
export * from "./dadosPessoais.vue?vue&type=script&lang=js&"
import style0 from "./dadosPessoais.vue?vue&type=style&index=0&id=4dff40df&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports